export default __webpack_public_path__ + "static/B0301-bdf0ddc66c7e2dabb3ab5f3756275d6a.png";